import { forwardRef } from "react";
import { Link } from "react-router-dom";

const LinkUtilityComponent = forwardRef<HTMLAnchorElement, { href: string }>((itemProps, ref) => (
  <Link to={itemProps.href} ref={ref} {...itemProps} />
));
export default LinkUtilityComponent;
